import { Popups, ColorInterface, ColorInterfacePopups } from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-sbeditor-tool-popups',
  templateUrl: './popups.component.html',
  styleUrls: ['./popups.component.scss'],
})
export class PopupsComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private workflow: any;
  public workflowAllowsImage: boolean;
  public tool: Popups;
  public colors: ColorInterfacePopups;
  public filename: string;
  public downloadTemplate: SafeUrl;

  constructor(
    private toolsService: ToolsService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private sanitizer: DomSanitizer
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    this.workflow = this.activatedRoute.snapshot.data.dataFlow.workflow;
    // console.log('Workflow: ', this.workflow);
    this.workflowAllowsImage = true;
    if (this.workflow.id === 3 || this.workflow.id === 6 || this.workflow.id === 7) {
      this.workflowAllowsImage = false;
    }
    this.generateTemplate();
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.popups) {
        this.tool = JSON.parse(JSON.stringify(res.popups));
        this.colors = JSON.parse(JSON.stringify(res.color.manual.popups));
        if (this.tool.data) {
          this.filename = 'Fichero JSON subido';
        }
      } else {
        console.error('popups tool not found');
        return;
      }
      // console.log(this.tool);
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public getTool(): { tool: Popups; colors: ColorInterfacePopups } {
    const tool = {
      tool: JSON.parse(JSON.stringify(this.tool)),
      colors: JSON.parse(JSON.stringify(this.colors)),
    };
    return tool;
  }
  // Deprecated
  /*   public apply(){
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      res.popups =  JSON.parse(JSON.stringify(this.tool));
      res.color.manual.popups = JSON.parse(JSON.stringify(this.colors.popups));
      console.log(res);
      this.sblibService.apply(res);
      this.toastrService.success("","Success")

    })
    this.subscriptions.push(tools$);
  } */

  public onFileDropped($event) {
    console.log($event);
    if ($event[0].type == '' || $event[0].size == 0 || $event[0].type != 'application/json') {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    this.tool.data = $event[0];
  }

  public deleteDroppedFile() {
    this.tool.data = null;
    this.filename = null;
  }

  public onFileSelected($event) {
    console.log($event);
    if (
      $event.target.files[0].type == '' ||
      $event.target.files[0].size == 0 ||
      $event.target.files[0].type != 'application/json'
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    const fileReader = new FileReader();
    fileReader.readAsText($event.target.files[0], 'UTF-8');
    fileReader.onload = () => {
      this.filename = $event.target.files[0].name;
      this.tool.data = JSON.parse(fileReader.result.toString());
    };
    fileReader.onerror = error => {
      console.log(error);
    };
  }

  private generateTemplate(): void {
    const template = {
      sections: {
        S_PR05: {
          textHeader: 'SECTION Header Title From DATA File',
          textBody: 'Esto es una línea.\nEsto es otra línea.\nY otra más.',
          textFooter: 'Footer Text From DATA File. Less is more!',
          price: '5.00',
        },
      },
      rows: {
        'S_PR05-9': {
          textHeader: 'ROW Header Title From DATA File',
          textBody: 'Esto es una línea.\nEsto es otra línea.\nY otra más.',
          textFooter: 'Footer Text From DATA File. Less is more!',
          price: '9.00',
        },
        'S_PR05-8': {
          textHeader: 'ROW Header Title From DATA File',
          textBody:
            '!!!Body Text From DATA File. I love cheese, especially cow dolcelatte. Pecorino jarlsberg caerphilly manchego cheesy grin port-salut camembert de normandie cheese strings.',
          textFooter: 'Footer Text From DATA File. Less is more!',
          price: '8.00',
        },
      },
      seats: {
        'S_PR05-9-1': {
          textHeader: 'SEAT Header Title From DATA File',
          textBody:
            '!!!Body Text From DATA File. I love cheese, especially cow dolcelatte. Pecorino jarlsberg caerphilly manchego cheesy grin port-salut camembert de normandie cheese strings. Camembert de normandie mozzarella goat cauliflower cheese taleggio the big cheese say cheese cheese on toast. Cow pepper jack.',
          textFooter: 'Footer Text From DATA File. Less is more!',
          price: '91.00',
        },
        'S_PR05-8-1': {
          textHeader: 'SEAT Header Title From DATA File',
          textBody:
            '!!!Body Text From DATA File. I love cheese, especially cow dolcelatte. Pecorino jarlsberg caerphilly manchego cheesy grin port-salut camembert de normandie cheese strings. Camembert de normandie mozzarella goat cauliflower cheese taleggio the big cheese say cheese cheese on toast. Cow pepper jack.',
          textFooter: 'Footer Text From DATA File. Less is more!',
          price: '81.00',
        },
      },
    };
    let data = JSON.stringify(template);
    this.downloadTemplate = this.sanitizer.bypassSecurityTrustUrl(
      'data:text/json;charset=UTF-8,' + encodeURIComponent(data)
    );
  }
}
